import { useCallback, useContext, useEffect, useLayoutEffect, useRef } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { TibiContext } from '../../context/ContextProvider'
import { getCurrentUser } from '../../services/api/me'
import { initializeAuthForCurrentRoute } from '../../services/auth/bootstrap'
import { subscribeToCurrentUserRefresh } from '../../services/auth/currentUserRefresh'

const isAdminRoute = (pathname: string) => pathname === '/dashboard' || pathname.startsWith('/dashboard/')

const AuthScopeSync = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { setValue } = useContext(TibiContext)
    const previousPathname = useRef(location.pathname)

    const refreshCurrentUser = useCallback(
        async (redirectToDashboard = false) => {
            try {
                const { data: user } = await getCurrentUser()
                if (!user) {
                    navigate('/login', { replace: true })
                    return
                }

                setValue({ user })

                if (redirectToDashboard) {
                    navigate('/dashboard', { replace: true })
                }
            } catch (_) {
                navigate('/login', { replace: true })
            }
        },
        [navigate, setValue]
    )

    useLayoutEffect(() => {
        initializeAuthForCurrentRoute(location.pathname)
    }, [location.pathname])

    useEffect(() => {
        const shouldLoadCurrentUser = previousPathname.current === '/login' && isAdminRoute(location.pathname)
        previousPathname.current = location.pathname

        if (!shouldLoadCurrentUser) {
            return
        }

        refreshCurrentUser()
    }, [location.pathname, refreshCurrentUser])

    useEffect(() => {
        return subscribeToCurrentUserRefresh(() => refreshCurrentUser(true))
    }, [refreshCurrentUser])

    return <Outlet />
}

export default AuthScopeSync
